// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3co2M","header":"ReportDetails_header__2v6L8","title":"ReportDetails_title__3FtfC","left":"ReportDetails_left__jAGSs"};